export const API_URL = process.env.API_URL || 'http://localhost:8000';
export const OBM_API_URL = process.env.OBM_API_URL || API_URL;
export const USER_CONFIG_API_URL = process.env.USER_CONFIG_API_URL || API_URL;
export const MOBEES_API_URL = process.env.MOBEES_API_URL || API_URL;
export const DEFAULT_TIMEOUT_IN_MS = 300 * 1000;
